export const MIDI_DEAL_PRODUCTS_REQUEST = 'MIDI_DEAL_PRODUCTS_REQUEST';
export const MIDI_DEAL_PRODUCTS_SUCCESS = 'MIDI_DEAL_PRODUCTS_SUCCESS';
export const MIDI_DEAL_PRODUCTS_FAIL = 'MIDI_DEAL_PRODUCTS_FAIL';

export const MIDI_DEAL_EVENT_REQUEST = 'MIDI_DEAL_EVENT_REQUEST';
export const MIDI_DEAL_EVENT_SUCCESS = 'MIDI_DEAL_EVENT_SUCCESS';
export const MIDI_DEAL_EVENT_FAIL = 'MIDI_DEAL_EVENT_FAIL';

export const MIDI_DEAL_ELIGIBILITY_REQUEST = 'MIDI_DEAL_ELIGIBILITY_REQUEST';
export const MIDI_DEAL_ELIGIBILITY_SUCCESS = 'MIDI_DEAL_ELIGIBILITY_SUCCESS';
export const MIDI_DEAL_ELIGIBILITY_FAIL = 'MIDI_DEAL_ELIGIBILITY_FAIL';

export const MIDI_DEAL_STATUS_REQUEST = 'MIDI_DEAL_STATUS_REQUEST';
export const MIDI_DEAL_STATUS_SUCCESS = 'MIDI_DEAL_STATUS_SUCCESS';
export const MIDI_DEAL_STATUS_FAIL = 'MIDI_DEAL_STATUS_FAIL';
